// API base URL. Configure via ui/.env (or CI build-arg) using REACT_APP_API_URL.
//   - Unset  -> "/api" (same-origin, production behind a reverse proxy such as
//               nginx that forwards /api to the NestJS service).
//   - Set    -> absolute prefix, e.g. "http://localhost/api" for dev.
const baseURL = process.env.REACT_APP_API_URL || '/api';

export { baseURL }